import { render, staticRenderFns } from "./select_notification.vue?vue&type=template&id=05c4061e"
import script from "./select_notification.vue?vue&type=script&lang=js"
export * from "./select_notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports